<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    date: {
      type: String
    }
  },
  data() {
    return {

    }
  }
}
</script>
<template>
  <v-dialog v-model="value" max-width="500" persistent>
    <v-card>
      <DialogBaseColoredTitle color="primary">{{
          $t('component.documentValidation.scheduleConfirmation.title') }}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText
        class="text-center"
        v-html="$t('component.documentValidation.scheduleConfirmation.content', { DATE: date })"
      ></DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn id="schedule-confirmation-dashboard-button" :to="{ name: 'dashboard' }" class="tertiary">
          {{ $t('button.dashboard') }}
        </v-btn>
        <v-spacer />
        <v-btn id="schedule-confirmation-orders-button" :to="{ name: 'orders' }" class="tertiary">
          {{ $t('button.orders')}}
        </v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
